import React from "react";
import { Chart } from "react-google-charts";

var moment = require('moment-timezone');

var firebase = require('firebase/app');
require('firebase/database');

const options = {
  backgroundColor: '#191d32',
  colors: ['#EDE7D9'],
  curveType: "function",
  lineWidth: 4,
  legend: { position: "none" },
  pointSize: 10,
  annotations: { stemColor: 'white', textStyle: { fontSize: 16 } },
  hAxis: {
          textStyle: {
            color: '#EDE7D9',
            fontSize: 16,
            fontName: 'Arial',

          },
          slantedText: true,
          slantedTextAngle: 15,
          showTextEvery: 1,
          textPosition: 'out'
          
        },
        vAxis: {
          title: 'Tide Heights',
          textStyle: {
            color: '#EDE7D9',
            fontSize: 18,
            bold: true
          },
          titleTextStyle: {
            color: '#EDE7D9',
            fontSize: 18,
            bold: true
          }
        },
};

export class TideChart extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      tournamentId: this.props.tournamentId,
      tourTides: ['x', 'tides'],
      sollunarData: [],
      tourLat: '',
      tourLon: '',
      tourTimeOffset: '',
      day1Date: '',
      day2Date: '',
      day3Date: '',
      day4Date: '',
    }
    this.tourRef = firebase.database().ref('tournaments');
  }
  
  componentWillMount() {
    this.tourRef.on('value', this.handleTournamentUpdate); 
  }
  
  componentWillUnmount() {
    this.tourRef.off('value', this.handleTournamentUpdate); 
  }
  
  handleTournamentUpdate = (snapshot) => {
    snapshot.forEach((snap) => {
      if(snap.key === this.props.tournamentId) {
        this.formatData(snap.val().tourTides._55);
        var day1 = new Date(snap.val().day1Date);
        this.setState({
          day1Date: snap.val().day1Date,
          day2Date: snap.val().day2Date,
          day3Date: snap.val().day3Date,
          day4Date: snap.val().day4Date,
          tourLat: snap.val().tourLat,
          tourLon: snap.val().tourLon,
          tourTimeOffset: snap.val().tourTimeOffset
        })
      }
    })
  }
  
  formatData = (data) => {
    var tideArray = [];
    data.forEach((tide) => {
      var tDate = moment(tide.date).tz('Americas/Mazatlan').format('ha z')
      tideArray.push([tDate, tide.height, tide.height])
    })
    this.setState({
      tourTides: tideArray
    })
  }
  
render() {
    return (
      <div className="tourTidesBox">
        {this.state.tourTides && this.state.tourTides.length > 1 ? <Chart
          chartType="LineChart"
          columns={[
            {
              type: "string",
              label: "Time"
            },
            {
              type: "number",
              label: "Tide Height"
            },
            {
              type: "number",
              role: "annotation"
            }
          ]}
          rows={this.state.tourTides}
          options={options}
          width="100%"
          height="250px"
        /> : null}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/TideChart.js